let menuConfig;
const setSidebarMenu = function (menu) {
    menuConfig = menu;
};
const getSidebarMenu = function () {
    return menuConfig;
};

export {
    setSidebarMenu, getSidebarMenu
}

export default {
    data() {
        return {
            menuData: menuConfig,

        }
    },
    computed:{
        defaultActive(){
            return this.$route.name;
        },
        isCollapse(){
            return this.$store.state.isCollapse;
        }
    },
    methods: {

    },
    render(){
        const menuItemSelect  = (name) => {
            if(this.$store.state.tabView.pages.length == 0){
                this.$router.push({name})
            }else{
                if(this.defaultActive != name){
                    if (name=='roleManagement'){
                        console.log('renyuan')
                        window.location.href='https://wedof-auth.autoai.com/web_authority/#/roleManagement?app_id=2'
                    }else if(name=='userManagement'){
                        console.log('zuzhi')
                        window.location.href='https://wedof-auth.autoai.com/web_authority/#/departmentTree?app_id=2'
                    }else{
                        this.$router.push({name})
                    }
                    
                };
            }
        }
        const MenuItem = function (item) {
            return <el-menu-item index={item.index} key={item.index} v-w-role={item.role} onClick={() => menuItemSelect(item.index)}>
                <i class={item.icon}></i><span slot="title">{item.title}</span>
            </el-menu-item>
        }
        return <el-menu default-active={this.defaultActive} collapse={this.isCollapse}>
            {this.menuData.map(item => {
                if(item.children.length){
                    return <el-submenu index={item.index} v-w-role={item.role}>
                        <template slot="title">
                            <i class={item.icon}></i>
                            <span slot="title">{item.title}</span>
                        </template>
                        {item.children.map(item => {
                            return MenuItem(item)
                        })}
                    </el-submenu>
                }else {
                    return MenuItem(item)
                }
            })}
        </el-menu>
    }
}
